export enum DashboardInspectionStatus {
  INSPECTION_LINK_SEND = 'inspection_link_send',
  ONGOING_CAPTURE = 'ongoing_capture',
  READY_FOR_REVIEW = 'ready_for_review',
  PDF_SENT = 'pdf_sent',
  FINALIZED = 'finalized',
}

export enum OwnershipFilter {
  OWN_RESOURCES = 'own_resources',
  ORGANIZATION_RESOURCES = 'organization_resources',
  ALL_RESOURCES = 'all_resources',
}

export interface DashboardInspection {
  inspectionId: string;
  status?: DashboardInspectionStatus;
  vin?: string;
  lastUpdated?: Date;
  inspectionStart?: Date;
  inspectionEnd?: Date;
}

export interface Pagination {
  rowsPerPage: number;
  start: number;
  end: number;
  totalItems: number;
}
